<div class="permissions-section">
  <h4 class="section-title">{{ 'fileManagement.permissions' | translate }}</h4>

  <!-- Save Alert Message -->
  @if (saveMessage) {
    <div [ngClass]="{'alert': true, 'alert-success': saveMessageType === 'success', 'alert-danger': saveMessageType === 'error'}" role="alert">
      <i [ngClass]="{'bi': true, 'bi-check-circle': saveMessageType === 'success', 'bi-exclamation-circle': saveMessageType === 'error'}" class="me-2"></i>
      {{ saveMessage }}
    </div>
  }

  <!-- Role Selection -->
  <div class="permission-input-group">
    <div class="form-group flex-grow-1">
      <label>{{ 'fileManagement.selectRole' | translate }}</label>
      <select [(ngModel)]="selectedRole" name="roleSelect" (change)="selectedRole && onRoleSelected(selectedRole)"
        [disabled]="isLoadingRoles">
        <option [ngValue]="null">-- {{ 'common.noData' | translate }} --</option>
        @for (role of allRoles; track trackByRoleId($index, role)) {
          <option [ngValue]="role">
            {{ role.typeName }}
          </option>
        }
      </select>
      @if (isLoadingRoles) {
        <small class="text-muted">{{ 'common.loading' | translate }}</small>
      }
    </div>
  </div>

  <!-- User Search with Autocomplete -->
  <div class="permission-input-group">
    <div class="form-group flex-grow-1 position-relative">
      <label>{{ 'fileManagement.selectUser' | translate }}</label>
      <div class="user-search-wrapper">
        <input type="text" class="form-control"
          [placeholder]="'fileManagement.searchPlaceholder' | translate"
          [(ngModel)]="userSearchTerm" (ngModelChange)="onUserSearchInput($event)"
          (focus)="showUserDropdown = userSearchTerm.length > 0" name="userSearch"
          [disabled]="isLoadingUsers" />
          <i class="bi bi-search"></i>

          <!-- User Autocomplete Dropdown -->
          @if (showUserDropdown && filteredUsers.length > 0) {
            <div class="user-dropdown">
              @for (user of filteredUsers; track trackByUserId($index, user)) {
                <div class="user-dropdown-item"
                  (click)="selectUserFromDropdown(user)">
                  <div class="user-info">
                    <div class="user-name">{{ user.fullName }}</div>
                    <div class="user-meta">{{ user.username }} • {{ user.email }}</div>
                  </div>
                </div>
              }
            </div>
          }

          <!-- Loading state -->
          @if (isLoadingUsers) {
            <div class="user-dropdown">
              <div class="user-dropdown-item">
                <span class="text-muted">{{ 'common.loading' | translate }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Permissions Grid -->
    <div class="permissions-grid">
      <h5 class="grid-title">
        <i class="bi bi-people-fill"></i>
        {{ 'fileManagement.userPermissions' | translate }} ({{ filePermissions.length }})
      </h5>

      @if (filePermissions.length === 0) {
        <div class="empty-permissions">
          <p>{{ 'fileManagement.noPermissions' | translate }}</p>
        </div>
      }

      @if (filePermissions.length > 0) {
        <div class="permissions-table">
          <div class="permissions-row header-row">
            <div class="col col-type">{{ 'common.name' | translate }}</div>
            <div class="col col-name">{{ 'common.name' | translate }}</div>
            <div class="col col-action">{{ 'common.actions' | translate }}</div>
          </div>
          @for (permission of filePermissions; track trackByPermissionId(i, permission); let i = $index) {
            <div class="permissions-row">
              <div class="col col-type">
                <span class="badge badge-user">
                  {{ 'common.name' | translate }}
                </span>
              </div>
              <div class="col col-name">
                {{ permission.userName }}
              </div>
              <div class="col col-action">
                <button type="button" class="btn-delete" (click)="removePermission(permission)"
                  [title]="'common.delete' | translate">
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            </div>
          }
        </div>
      }

      <!-- Save Button for Independent Permission Save -->
      @if (fileId) {
        <div class="permissions-actions mt-3">
          <button type="button" class="btn btn-primary" (click)="savePermissions()" [disabled]="isSavingPermissions">
            @if (!isSavingPermissions) {
              <i class="bi bi-check-circle me-2"></i>
            }
            @if (!isSavingPermissions) {
              <span>{{ 'common.save' | translate }}</span>
            }
            @if (isSavingPermissions) {
              <span>{{ 'common.processing' | translate }}</span>
            }
          </button>
        </div>
      }
    </div>
  </div>
